import './App.css';
import Screens from './screens/Screens.jsx'

function App() {
  return (
    <div className="App">
      <Screens />
    </div>
  );
}

export default App;
